<template>
    <div id="UploadWrapper" style="justify-content: unset; align-content: unset; height: unset;">
        
        <div id="UploadTabs">
            <div @click="ShowTab(0)"
                 :class="{'ActiveUploadTab': CurrentTab === 0, 'UploadTab': true}">
                計画
            </div>
            <div @click="ShowTab(2)"
                 :class="{'ActiveUploadTab': CurrentTab === 2, 'UploadTab': true}">
                年末在庫
            </div>
            <div @click="ShowTab(3)" 
                :class="{'ActiveUploadTab': CurrentTab === 3, 'UploadTab': true}">
                えいや～調整
            </div>
            <div @click="ShowTab(4)"
                :class="{'ActiveUploadTab': CurrentTab === 4, 'UploadTab': true}">
                金型
            </div>
            <div @click="ShowTab(1)" title="計画明細、在庫明細、成約票、不具合カ所 "
                 :class="{'ActiveUploadTab': CurrentTab === 1, 'UploadTab': true}">
                その他
            </div>
        </div>
        <div id="MenuContent">
            <div v-if="CurrentTab === 1">
                <input type="file" id="uploadfile" @change="HandleFileChange"/>
                <p id="loading"></p>
            </div>

            <div v-if="CurrentTab === 1 && UploadedExcelFile !== null && SheetList.length > 0">
                <p>シートを選んでください</p>
                <GenericDropdown id="SheetList" :options="SheetList" @change="HasSelectedSheet" v-model="SelectedSheet"/>
            </div>

            <div v-if="CurrentTab === 1 && HasSelectedFile === true" id="ButtonOptions" :class="{'ButtonsVisible': CheckedSheets === true}">
                <div id="Import_Seiyakuhyou" class="ImportSelectionButton" @click="ImportSeiyakuhyou">
                    成約票
                </div>
                <div id="Import_Zaiko" class="ImportSelectionButton" @click="ImportZaiko">
                    在庫明細
                </div>
                <div id="Import_Keikakumeisai" class="ImportSelectionButton" @click="ImportKeikakumeisai">
                    計画明細
                </div>
                <div id="Import_Result" class="ImportSelectionButton" @click="ImportResult">
                    実績
                </div>
                <div id="Import_ReturnItems" class="ImportSelectionButton" @click="ImportReturnItems">
                    不具合カ所
                </div>
            </div>

            <div v-if="CurrentTab === 0" style="display: flex; width: 100%; justify-content: center; padding: 30px 0px;">
                <div class="EstimationKeikakuImport" id="KeikakuContainer">
                    <div>
                        <label for="Upload_Keikaku"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Keikaku">計画</label>
                        <input id="Upload_Keikaku" type="file" @change="OnSelectKeikaku" />
                    </div>
                    <div>
                        OR
                    </div>
                    <div>
                        <label for="Upload_Sep_Keikaku"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Sep_Keikaku">分けた計画</label>
                        <input id="Upload_Sep_Keikaku" type="file" @change="OnSelectSepKeikaku" />
                    </div>
                    <div style="margin: 20px 0px;">
                        <label for="Date_Keikaku">ファイル日付</label>
                        <input id="Date_Keikaku" type="date" v-model="KeikakuFileDate" />
                    </div>
                    <div>
                        <label for="Year_Keikaku">計画の年</label>
                        <input id="Year_Keikaku" type="number" v-model="KeikakuYear" />
                    </div>
                    <div style="display: grid; margin-top: 20px;">
                        <div v-if="EstimationUpload_Keikaku !== null">計画ファイル名：</div>
                        <div>{{ EstimationUpload_Keikaku?.name }}</div>
                        <div v-if="EstimationUpload_SepKeikaku !== null">分けた計画ファイル名：</div>
                        <div>{{ EstimationUpload_SepKeikaku?.name }}</div>
                    </div>
                </div>
                <div class="EstimationKeikakuImport" id="KeikakuRef1Container">
                    <div>
                        <label for="Upload_Rev_Keikaku_1"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Rev_Keikaku_1">1.見直計画</label>
                        <input id="Upload_Rev_Keikaku_1" type="file" @change="OnSelectKeikakuRef_1" />
                    </div>
                    <div>
                        OR
                    </div>
                    <div>
                        <label for="Upload_Sep_Keikaku"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Sep_Keikaku">分けた1.見直計画</label>
                        <input id="Upload_Sep_Keikaku" type="file" @change="OnSelectSepKeikakuRef_1" />
                    </div>
                    <div style="margin: 20px 0px;">
                        <label for="Date_Rev_Keikaku_1">ファイル日付</label>
                        <input id="Date_Rev_Keikaku_1" type="date" v-model="KeikakuRev1FileDate" />
                    </div>
                    <div>
                        <label for="Year_Rev_Keikaku_1">計画の年</label>
                        <input id="Year_Rev_Keikaku_1" type="number" v-model="KeikakuRev1Year" />
                    </div>
                    <div style="display: grid; margin-top: 20px;">
                        <div v-if="EstimationUpload_KeikakuRef1 !== null">計画ファイル名：</div>
                        <div>{{ EstimationUpload_KeikakuRef1?.name }}</div>
                        <div v-if="EstimationUpload_SepKeikakuRef1 !== null">分けた計画ファイル名：</div>
                        <div>{{ EstimationUpload_SepKeikakuRef1?.name }}</div>
                    </div>
                </div>
                <div class="EstimationKeikakuImport" id="KeikakuRef2Container">
                    <div>
                        <label for="Upload_Rev_Keikaku_2"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Rev_Keikaku_2">2.見直計画</label>
                        <input id="Upload_Rev_Keikaku_2" type="file" @change="OnSelectKeikakuRef_2" />
                    </div>
                    <div>
                        OR
                    </div>
                    <div>
                        <label for="Upload_Sep_Keikaku"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Sep_Keikaku">分けた2.見直計画</label>
                        <input id="Upload_Sep_Keikaku" type="file" @change="OnSelectSepKeikakuRef_2" />
                    </div>
                    <div style="margin: 20px 0px;">
                        <label for="Date_Rev_Keikaku_2">ファイル日付</label>
                        <input id="Date_Rev_Keikaku_2" type="date" v-model="KeikakuRev2FileDate" />
                    </div>
                    <div>
                        <label for="Year_Rev_Keikaku_2">計画の年</label>
                        <input id="Year_Rev_Keikaku_2" type="number" v-model="KeikakuRev2Year" />
                    </div>
                    <div style="display: grid; margin-top: 20px;">
                        <div v-if="EstimationUpload_KeikakuRef2 !== null">計画ファイル名：</div>
                        <div>{{ EstimationUpload_KeikakuRef2?.name }}</div>
                        <div v-if="EstimationUpload_SepKeikakuRef2 !== null">分けた計画ファイル名：</div>
                        <div>{{ EstimationUpload_SepKeikakuRef2?.name }}</div>
                    </div>
                </div>
                <div class="EstimationKeikakuImport" id="KeikakuRef3Container">
                    <div>
                        <label for="Upload_Rev_Keikaku_3"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Rev_Keikaku_3">3.見直計画</label>
                        <input id="Upload_Rev_Keikaku_3" type="file" @change="OnSelectKeikakuRef_3" />
                    </div>
                    <div>
                        OR
                    </div>
                    <div>
                        <label for="Upload_Sep_Keikaku"><img width="24" height="24" src="@/assets/Icon_Upload.svg" /></label>
                        <label for="Upload_Sep_Keikaku">分けた3.見直計画</label>
                        <input id="Upload_Sep_Keikaku" type="file" @change="OnSelectSepKeikakuRef_3" />
                    </div>
                    <div style="margin: 20px 0px;">
                        <label for="Date_Rev_Keikaku_3">ファイル日付</label>
                        <input id="Date_Rev_Keikaku_3" type="date" v-model="KeikakuRev3FileDate" />
                    </div>
                    <div>
                        <label for="Year_Rev_Keikaku_3">計画の年</label>
                        <input id="Year_Rev_Keikaku_3" type="number" v-model="KeikakuRev3Year" />
                    </div>
                    <div style="display: grid; margin-top: 20px;">
                        <div v-if="EstimationUpload_KeikakuRef3 !== null">計画ファイル名：</div>
                        <div>{{ EstimationUpload_KeikakuRef3?.name }}</div>
                        <div v-if="EstimationUpload_SepKeikakuRef3 !== null">分けた計画ファイル名：</div>
                        <div>{{ EstimationUpload_SepKeikakuRef3?.name }}</div>
                    </div>
                </div>
            </div>
            <div v-if="CurrentTab === 0" style="display: flex; justify-content: center; margin-top: 10px;">
                <div>
                    <p style="padding-left: 27px; margin-bottom: 8px; margin-top: 0px;">6月破壊経費</p>
                    <input id="JuneDestructionCost" style="text-align: center; font-size: 1.2rem; width: 100px;" value="260" @change="(event)=>{this.JuneDesctructionCost = event.target.value;}" />
                    万円
                </div>
                <div style="margin-left: 50px;">
                    <p style="padding-left: 27px; margin-bottom: 8px; margin-top: 0px;">11月破壊経費</p>
                    <input id="NovemberDestructionCost" style="text-align: center; font-size: 1.2rem; width: 100px;" value="320" @change="(event)=>{this.NovemberDesctructionCost = event.target.value;}" />
                    万円
                </div>
            </div>
            <div v-if="CurrentTab === 0" style="display: grid; justify-content: center; margin-top: 30px;">
                <div id="UploadEstimationsButton" style="width: 256px;" class="Button ButtonNormal Disabled NoSelect" @click="UploadEstimationKeikaku">
                    {{ UploadKeikakuButtonText }}
                </div>
            </div>

            <div v-if="CurrentTab === 2">
                <div>{{ YearEndStockYear }}の年末在庫：</div>
                <div>
                    <input v-model="YearEndStock" style="text-align: center; font-size: 16px; width: 100px; margin: 10px 0px;"/>
                    万円
                </div>
                <div class="Button ButtonNormal NoSelect" style="width: 100px;"
                     @click="SubmitYearEndStock">
                    提出
                </div>
                <p v-if="YearEndStockSubmissionResult !== ''">
                    {{ YearEndStockSubmissionResult }}
                </p>
            </div>

            <div v-if="CurrentTab === 3">
                <div>{{ EyaAdjustmentYear }}のえいや～調整：</div>
                <GenericDropdown :elementID="'ProfAdjDropdown'" :options="ProfitAdjustmentYears" :SelectedIndex="ProfitAdjustmentSelectedIndex" :OnChange="GetProfitAdjustmentValues" />
                <div id="EyaGrid">
                    <div class="EyaGridItem" v-for="adjustment in ProfitAdjustmentData" :key="adjustment">
                        <div style="margin-top: 16px; margin-bottom: 8px;">{{ adjustment.month }}月</div>
                        <div>
                            <input style="width: 100%;" v-model="adjustment.provProfit" />
                        </div>
                    </div>
                </div>
                <div class="Button ButtonNormal NoSelect"
                     style="margin-top: 20px; width: 100px;"
                     @click="SubmitProfitAdjustment">
                    提出
                </div>
            </div>

            <div v-if="CurrentTab === 4">
                <input type="file" id="uploadfile" @change="HandleFileChange"/>
                <p id="loading"></p>

                <div v-if="SheetList.length > 0">
                    <p>シートを選んでください</p>
                    <GenericDropdown id="SheetList" :options="SheetList" @change="HasSelectedSheet" v-model="SelectedSheet"/>
                </div>

                <div v-if="SelectedSheet !== ''" style="margin-top: 30px;">
                    <div id="Upload_Mold" class="Button ButtonNormal NoSelect" @click="ImportMold" >金型データをインポート</div>
                </div>
            </div>

            <div id="UploadProgress">
                
            </div>
        </div>
    </div>
</template>

<script>
import ExcelJS from 'exceljs';
import GenericDropdown from '@/components/GenericDropdown.vue';
import { ImportZaikouData } from '@/utils/ImportZaikou';
import { ImportKeikakumeisaiData } from '@/utils/ImportKeikakumeisai';
import { ImportReturnedItemsData } from '@/utils/ImportReturnedItemsData';
import { ImportKeikaku } from '@/utils/ImportKeikaku';
import { ImportSeparatedKeikaku } from '@/utils/ImportSeparatedKeikaku';
import { ImportResultData } from '@/utils/ImportResult';
import { ImportMoldData } from '@/utils/ImportMold';
import axios from 'axios';

export default {
    components:{
        GenericDropdown,
    },
    mounted() {
        const hBtn = document.getElementById('H_Btn_Upload');
        if (hBtn !== null)
        {
            if (hBtn.classList.contains('HeaderButtonActive') === false)
            {
                hBtn.classList.add('HeaderButtonActive');
            }
        }
    },
    methods:{
        ShowTab(index)
        {
            this.CurrentTab = index;

            this.SheetList = [];
            this.SelectedSheet = '';

            if (this.CurrentTab === 2)
            {
                this.YearEndStockSubmissionResult = '';
                this.GetLastYearEndStock();
            }
            else if (this.CurrentTab === 3)
            {
                // It's prov profit but I don't
                // want to write that long name
                // everywhere...
                this.GetProfitAdjustmentList();
            }
        },
        async SubmitYearEndStock()
        {
            const data = {
                SessionToken: this.$GetToken(),
                Year: this.YearEndStockYear,
                Stock: this.YearEndStock,
            };

            console.log('Submit year-end stock', data);

            await axios.post(`${process.env.VUE_APP_BACKEND_URL}keikaku/yearendstock/set`, data)
            .then(response => {
                console.log('year end stock upload result', response);

                if (response.status === 200)
                {
                    this.YearEndStockSubmissionResult = `${this.YearEndStockYear}年の年末在庫をアップデートしました。`;
                    setTimeout(()=>{
                        this.YearEndStockSubmissionResult = '';
                    }, 3000);
                }
                else if (response.status === 201)
                {
                    this.YearEndStockSubmissionResult = `${this.YearEndStockYear}年の年末在庫を登録しました。`;
                    setTimeout(()=>{
                        this.YearEndStockSubmissionResult = '';
                    }, 3000);
                }
                else
                {
                    this.YearEndStockSubmissionResult = `問題が出てしまいました: ${response}`;
                }
            })
            .catch(error => {
                console.log('Upload year end stock error', error);
            });
        },
        async GetLastYearEndStock()
        {
            const data = {
                SessionToken: this.$GetToken(),
                Year: this.YearEndStockYear,
            };

            await axios.post(`${process.env.VUE_APP_BACKEND_URL}keikaku/yearendstock/get`, data)
            .then(response => {
                console.log('Year end stock', response.data);
                this.YearEndStock = response.data.Stock;
            })
            .catch(error => {
                console.log('Get last year end stock error', error);
            });
        },
        async GetProfitAdjustmentList()
        {
            const data = {
                SessionToken: this.$GetToken(),
            };

            await axios.post(`${process.env.VUE_APP_BACKEND_URL}provprofitadjustment/list`, data)
            .then(response => {
                console.log('[GetProfitAdjustmentList]', response.data);
                const years = response.data;
                this.ProfitAdjustmentYears = [];
                const now = new Date().getFullYear();
                for (let i = 0; i < years.length; i ++)
                {
                    if (years[i] === now)
                    {
                        this.ProfitAdjustmentSelectedIndex = i;
                    }
                    this.ProfitAdjustmentYears.push({ label: years[i], value: i });
                }
            })
            .catch(error => {
                console.log('[GetProfitAdjustmentList] error', error);
            });
        },
        async GetProfitAdjustmentValues(change)
        {
            this.ProfitAdjustmentSelectedIndex = change.target.selectedIndex;

            const data = {
                SessionToken: this.$GetToken(),
                Year: this.ProfitAdjustmentYears[this.ProfitAdjustmentSelectedIndex].label
            };

            this.EyaAdjustmentYear = data.Year;

            await axios.post(`${process.env.VUE_APP_BACKEND_URL}provprofitadjustment/get`, data)
            .then(response => {
                this.ProfitAdjustmentData = response.data;
            })
            .catch(error => {
                console.log('[GetProfitAdjustmentValues] error', error);
            });
        },
        async SubmitProfitAdjustment()
        {
            const data = {
                SessionToken: this.$GetToken(),
                Data: this.ProfitAdjustmentData
            };

            console.log('submit adjustment data', data);

            await axios.post(`${process.env.VUE_APP_BACKEND_URL}provprofitadjustment/get`, data)
            .then(response => {
                alert(response.data);
            })
            .catch(error => {
                console.log('[GetProfitAdjustmentValues] error', error);
            });
        },
        async UploadEstimationKeikaku()
        {
            if (this.IsUploadingKeikaku === false)
            {
                this.IsUploadingKeikaku = true;
                this.UploadKeikakuButtonText = 'インポート中';
                const juneDestructionCost = parseInt(document.getElementById('JuneDestructionCost').value);
                const novemberDestructionCost = parseInt(document.getElementById('NovemberDestructionCost').value);

                const keikakuType = 0;
                const keikakuRev1Type = 1;
                const keikakuRev2Type = 2;
                const keikakuRev3Type = 3;

                const keikakuData = await ImportKeikaku(
                    { June: juneDestructionCost, November: novemberDestructionCost },
                    this.EstimationUpload_Keikaku ? { File: this.EstimationUpload_Keikaku, Filename: this.EstimationUpload_Keikaku.name, Date: new Date(this.KeikakuFileDate), Revision: keikakuType, KeikakuYear: this.KeikakuYear } : null,
                    this.EstimationUpload_KeikakuRef1 ? { File: this.EstimationUpload_KeikakuRef1, Filename: this.EstimationUpload_KeikakuRef1.name, Date: new Date(this.KeikakuRev1FileDate), Revision: keikakuRev1Type, KeikakuYear: this.KeikakuRev1Year } : null,
                    this.EstimationUpload_KeikakuRef2 ? { File: this.EstimationUpload_KeikakuRef2, Filename: this.EstimationUpload_KeikakuRef2.name, Date: new Date(this.KeikakuRev2FileDate), Revision: keikakuRev2Type, KeikakuYear: this.KeikakuRev2Year } : null,
                    this.EstimationUpload_KeikakuRef3 ? { File: this.EstimationUpload_KeikakuRef3, Filename: this.EstimationUpload_KeikakuRef3.name, Date: new Date(this.KeikakuRev3FileDate), Revision: keikakuRev3Type, KeikakuYear: this.KeikakuRev3Year } : null,
                );

                const separatedKeikakuData = await ImportSeparatedKeikaku(
                    this.EstimationUpload_SepKeikaku ? { File: this.EstimationUpload_SepKeikaku, Filename: this.EstimationUpload_SepKeikaku.name, Date: new Date(this.KeikakuFileDate), Revision: keikakuType, KeikakuYear: this.KeikakuYear } : null,
                    this.EstimationUpload_SepKeikakuRef1 ? { File: this.EstimationUpload_SepKeikakuRef1, Filename: this.EstimationUpload_SepKeikakuRef1.name, Date: new Date(this.KeikakuRev1FileDate), Revision: keikakuRev1Type, KeikakuYear: this.KeikakuRev1Year } : null,
                    this.EstimationUpload_SepKeikakuRef2 ? { File: this.EstimationUpload_SepKeikakuRef2, Filename: this.EstimationUpload_SepKeikakuRef2.name, Date: new Date(this.KeikakuRev2FileDate), Revision: keikakuRev2Type, KeikakuYear: this.KeikakuRev2Year } : null,
                    this.EstimationUpload_SepKeikakuRef3 ? { File: this.EstimationUpload_SepKeikakuRef3, Filename: this.EstimationUpload_SepKeikakuRef3.name, Date: new Date(this.KeikakuRev3FileDate), Revision: keikakuRev3Type, KeikakuYear: this.KeikakuRev3Year } : null,
                );

                console.log('Separated keikaku', separatedKeikakuData);

                this.UploadKeikakuButtonText = 'アップロード中';

                console.log('received extracted keikaku data', keikakuData);

                let data = null;

                if (keikakuData.length > 0)
                {
                    data = {
                        SessionToken: this.$GetToken(),
                        Data: keikakuData
                    };
    
                    const uploadResult = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/keikaku`, data, {
                        headers:
                        {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async response => {
                        console.log(`Keikaku upload response`, response.data);
                        return response.data;
                    })
                    .catch(error =>
                    {
                        console.log(`Keikaku upload received an error`, error);
                        if (error.response.status != 500)
                        {
                            this.$HandleBadRequest(error.response.status, error.response.data);
                        }

                        return null;
                    });

                    console.log('Upload keikaku result', uploadResult);
                }

                if (separatedKeikakuData.length > 0)
                {
                    data = {
                        SessionToken: this.$GetToken(),
                        Data: separatedKeikakuData
                    };

                    const uploadResult = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/separatedkeikaku`, data)
                    .then(async response => {
                        console.log(`Separated keikaku upload response`, response.data);
                        return response.data;
                    })
                    .catch(error => {
                        console.log(`Separated keikaku upload received an error`, error);
                        if (error.response.status != 500)
                        {
                            this.$HandleBadRequest(error.response.status, error.response.data);
                        }

                        return null;
                    })

                    console.log('Upload separated keikaku result', uploadResult);
                }

                this.UpdateKeikakuSelectVisual(document.getElementById('KeikakuContainer').firstChild, false);
                this.UpdateKeikakuSelectVisual(document.getElementById('KeikakuRef1Container').firstChild, false);
                this.UpdateKeikakuSelectVisual(document.getElementById('KeikakuRef2Container').firstChild, false);
                this.UpdateKeikakuSelectVisual(document.getElementById('KeikakuRef3Container').firstChild, false);

                this.EstimationUpload_Keikaku = null;
                this.EstimationUpload_KeikakuRef1 = null;
                this.EstimationUpload_KeikakuRef2 = null;
                this.EstimationUpload_KeikakuRef3 = null;

                this.UploadKeikakuButtonText = 'ファイルを選択してください';
                this.IsUploadingKeikaku = false;
            }
        },
        ValidateUploadButton()
        {
            const t = document.getElementById('UploadEstimationsButton');

            if (this.EstimationUpload_Keikaku !== null ||
                this.EstimationUpload_SepKeikaku !== null ||
                this.EstimationUpload_KeikakuRef1 !== null ||
                this.EstimationUpload_SepKeikakuRef1 !== null ||
                this.EstimationUpload_KeikakuRef2 !== null ||
                this.EstimationUpload_SepKeikakuRef2 !== null ||
                this.EstimationUpload_KeikakuRef3 !== null ||
                this.EstimationUpload_SepKeikakuRef3 !== null)
            {
                t.classList.remove('Disabled');
                this.UploadKeikakuButtonText = 'アップロードする';
            }
            else
            {
                if (t.classList.contains('Disabled') === false)
                {
                    t.classList.add('Disabled');
                    this.UploadKeikakuButtonText = 'ファイルを選択してください';
                }
            }
        },
        OnSelectKeikaku(event)
        {
            this.EstimationUpload_SepKeikaku = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_Keikaku = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectSepKeikaku(event)
        {
            this.EstimationUpload_Keikaku = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_SepKeikaku = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectKeikakuRef_1(event)
        {
            this.EstimationUpload_SepKeikakuRef1 = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_KeikakuRef1 = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectSepKeikakuRef_1(event)
        {
            this.EstimationUpload_KeikakuRef1 = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_SepKeikakuRef1 = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectKeikakuRef_2(event)
        {
            this.EstimationUpload_SepKeikakuRef2 = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_KeikakuRef2 = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectSepKeikakuRef_2(event)
        {
            this.EstimationUpload_KeikakuRef2 = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_SepKeikakuRef2 = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectKeikakuRef_3(event)
        {
            this.EstimationUpload_SepKeikakuRef3 = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_KeikakuRef3 = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        OnSelectSepKeikakuRef_3(event)
        {
            this.EstimationUpload_KeikakuRef3 = null;
            this.UpdateKeikakuSelectVisual(event.target.parentNode, event.target.files.length === 1);
            this.EstimationUpload_SepKeikakuRef3 = event.target.files.length > 0 ? event.target.files[0] : null;
            this.ValidateUploadButton();
        },
        UpdateKeikakuSelectVisual(target, valid)
        {
            if (valid === true &&
                target.classList.contains('SelectedKeikakuFile') === false)
            {
                target.classList.add('SelectedKeikakuFile');
            }
            else if (valid === false)
            {
                target.classList.remove('SelectedKeikakuFile');
            }
        },
        async UploadZaiko(zaikomeisaiData, fileInfo)
        {
            if (zaikomeisaiData === null ||
                zaikomeisaiData === undefined)
            {
                return;
            }
            
            const btn = document.getElementById('DataUploadBtn');
            btn.textContent = 'アップロード中';
            btn.onclick = null;

            try
            {
                const batchSize = 5;
                const uploadProgressContainer = document.getElementById('UploadProgress');

                const uploadProgress = document.createElement('div');
                uploadProgress.style.marginTop = '20px';
                uploadProgress.style.width = '400px';
                uploadProgress.style.height = '40px';
                uploadProgress.style.border = '1px solid black';
                uploadProgress.style.position = 'relative';
                uploadProgress.style.backgroundColor = '#b3b3b3';
                uploadProgress.style.borderRadius = '10px';
                uploadProgressContainer.append(uploadProgress);

                const uploadProgressBar = document.createElement('div');
                uploadProgressBar.style.width = '0%';
                uploadProgressBar.style.height = '100%';
                uploadProgressBar.style.backgroundColor = '#87beb1';
                uploadProgressBar.style.borderRadius = '10px';
                uploadProgress.append(uploadProgressBar);

                const uploadProgressValue = document.createElement('div');
                uploadProgressValue.style.width = '100%';
                uploadProgressValue.style.height = '100%';
                uploadProgressValue.style.display = 'grid';
                uploadProgressValue.style.placeContent = 'center';
                uploadProgressValue.style.color = '#23ab30';
                uploadProgressValue.style.position = 'absolute';
                uploadProgressValue.style.top = '0px';
                uploadProgressValue.style.left = '0px';
                uploadProgressValue.style.color = 'white';
                uploadProgress.append(uploadProgressValue);
                
                const batches = Math.ceil(zaikomeisaiData.length / batchSize);

                uploadProgressValue.textContent = `0/${batches}`;

                for(let i = 0; i < batches; i++)
                {
                    const batchStart = i * batchSize;
                    const batchEnd = Math.min((i + 1) * batchSize, zaikomeisaiData.length);
                    const batch = zaikomeisaiData.slice(batchStart, batchEnd);

                    const data = {
                        SessionToken: this.$GetToken(),
                        Data: batch,
                        BatchNumber: (i + 1),
                        FileInfo: fileInfo,
                    };

                    console.log('send upload zaiko request to ' + `${process.env.VUE_APP_BACKEND_URL}upload/zaikomeisai`, data);
                    let result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/zaikomeisai`, data, {
                        headers:
                        {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async response =>{
                        console.log(`Zaikomeisai batch #${i + 1} upload response`, response.data);
                        return { success: true };
                    })
                    .catch(error =>
                    {
                        console.log(`Batch #${i + 1} received an error`, error);
                        if (error.response.status != 500)
                        {
                            this.$HandleBadRequest(error.response.status, error.response.data);
                        }

                        return { success: false, error: error.response.status };
                    });

                    if (result.success === false)
                    {
                        uploadProgressValue.textContent = 'Error! ' + result.error;
                        break;
                    }

                    uploadProgressBar.style.width = `${Math.floor((i + 1) * 100 / batches)}%`;
                    uploadProgressValue.textContent = `${i + 1}/${batches}`;
                }

                btn.textContent = 'OK';
                btn.onclick = function(event){
                    uploadProgress.remove();
                    this.SelectedSheet = '';
                    document.getElementById('SheetList').selectedIndex = -1;
                    event.target.remove();
                };
            }
            catch (err)
            {
                console.error('Could not upload Keikakumeisai', err);
            }
        },
        async UploadKeikaku(keikakumeisaiData, fileInfo)
        {
            if (keikakumeisaiData === null ||
                keikakumeisaiData === undefined)
            {
                return;
            }

            const btn = document.getElementById('DataUploadBtn');
            btn.textContent = 'アップロード中';
            btn.onclick = null;

            try
            {
                const batchSize = 25;
                const uploadProgressContainer = document.getElementById('UploadProgress');

                const uploadProgress = document.createElement('div');
                uploadProgress.style.marginTop = '20px';
                uploadProgress.style.width = '400px';
                uploadProgress.style.height = '40px';
                uploadProgress.style.border = '1px solid black';
                uploadProgress.style.position = 'relative';
                uploadProgress.style.backgroundColor = '#b3b3b3';
                uploadProgress.style.borderRadius = '10px';
                uploadProgressContainer.append(uploadProgress);

                const uploadProgressBar = document.createElement('div');
                uploadProgressBar.style.width = '0%';
                uploadProgressBar.style.height = '100%';
                uploadProgressBar.style.backgroundColor = '#87beb1';
                uploadProgressBar.style.borderRadius = '10px';
                uploadProgress.append(uploadProgressBar);

                const uploadProgressValue = document.createElement('div');
                uploadProgressValue.style.width = '100%';
                uploadProgressValue.style.height = '100%';
                uploadProgressValue.style.display = 'grid';
                uploadProgressValue.style.placeContent = 'center';
                uploadProgressValue.style.color = '#23ab30';
                uploadProgressValue.style.position = 'absolute';
                uploadProgressValue.style.top = '0px';
                uploadProgressValue.style.left = '0px';
                uploadProgressValue.style.color = 'white';
                uploadProgress.append(uploadProgressValue);
                
                const batches = Math.ceil(keikakumeisaiData.length / batchSize);

                uploadProgressValue.textContent = `0/${batches}`;

                let failedCount = 0;

                for(let i = 0; i < batches; i++)
                {
                    const batchStart = i * batchSize;
                    const batchEnd = Math.min((i + 1) * batchSize, keikakumeisaiData.length);
                    const batch = keikakumeisaiData.slice(batchStart, batchEnd);

                    const data = {
                        SessionToken: this.$GetToken(),
                        Data: batch,
                        BatchNumber: (i + 1),
                        FileInfo: fileInfo,
                    };

                    console.log('send upload keikaku request to ' + `${process.env.VUE_APP_BACKEND_URL}upload/keikakumeisai`, data);
                    const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/keikakumeisai`, data, {
                        headers:
                        {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async response =>{
                        console.log(`Keikakumeisai batch #${i + 1} upload response`, response.data);
                        return response.data;
                    })
                    .catch(error =>
                    {
                        console.log(`Batch #${i + 1} received an error`, error);
                        if (error.response.status != 500)
                        {
                            this.$HandleBadRequest(error.response.status, error.response.data);
                        }
                        return null;
                    });

                    uploadProgressBar.style.width = `${Math.floor((i + 1) * 100 / batches)}%`;
                    uploadProgressValue.textContent = `${i + 1}/${batches}`;

                    if (result !== null)
                    {
                        failedCount += result.FailedCount;
                    }
                }

                if (failedCount > 0)
                {
                    const wrapper = document.getElementById('UploadWrapper');
                    const errorMessage = document.createElement('div');
                    errorMessage.style.color = 'red';
                    errorMessage.textContent = `${failedCount}回エラーがありました。詳細についてはコンソールを確認してください。`;
                    wrapper.append(errorMessage);
                }

                btn.textContent = 'OK';
                btn.onclick = function(event){
                    const missingInfo = document.getElementById('MissingInfo');
                    if (missingInfo !== null)
                    {
                        missingInfo.remove();
                    }
                    uploadProgress.remove();
                    this.SelectedSheet = '';
                    document.getElementById('SheetList').selectedIndex = -1;
                    event.target.remove();
                };
            }
            catch (err)
            {
                console.error('Could not upload Keikakumeisai', err);
            }
        },
        async UploadResultData(resultData, fileInfo)
        {
            if (resultData === null ||
                resultData === undefined)
            {
                return;
            }

            const btn = document.getElementById('DataUploadBtn');
            btn.textContent = 'アップロード中';
            btn.onclick = null;

            const data = {
                SessionToken: this.$GetToken(),
                Data: resultData,
                FileInfo: fileInfo,
            };

            console.log('send upload result data request to ' + `${process.env.VUE_APP_BACKEND_URL}upload/results`, data);
            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/results`, data)
            .then(async response => {
                return response.data;
            })
            .catch(error =>
            {
                console.log(`Result upload received an error`, error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });

            console.log("Upload result data result", result);

            btn.textContent = 'OK';
            btn.onclick = function(event){
                const missingInfo = document.getElementById('MissingInfo');
                if (missingInfo !== null)
                {
                    missingInfo.remove();
                }
                this.SelectedSheet = '';
                document.getElementById('SheetList').selectedIndex = -1;
                event.target.remove();
            };
        },
        async UploadReturnedItems(returnedItemsData)
        {
            if (returnedItemsData === null ||
                returnedItemsData === undefined)
            {
                return;
            }

            const btn = document.getElementById('DataUploadBtn');
            btn.textContent = 'アップロード中';
            btn.onclick = null;

            try
            {
                const batchSize = 25;
                const uploadProgressContainer = document.getElementById('UploadProgress');

                const uploadProgress = document.createElement('div');
                uploadProgress.style.marginTop = '20px';
                uploadProgress.style.width = '400px';
                uploadProgress.style.height = '40px';
                uploadProgress.style.border = '1px solid black';
                uploadProgress.style.position = 'relative';
                uploadProgress.style.backgroundColor = '#b3b3b3';
                uploadProgress.style.borderRadius = '10px';
                uploadProgressContainer.append(uploadProgress);

                const uploadProgressBar = document.createElement('div');
                uploadProgressBar.style.width = '0%';
                uploadProgressBar.style.height = '100%';
                uploadProgressBar.style.backgroundColor = '#87beb1';
                uploadProgressBar.style.borderRadius = '10px';
                uploadProgress.append(uploadProgressBar);

                const uploadProgressValue = document.createElement('div');
                uploadProgressValue.style.width = '100%';
                uploadProgressValue.style.height = '100%';
                uploadProgressValue.style.display = 'grid';
                uploadProgressValue.style.placeContent = 'center';
                uploadProgressValue.style.color = '#23ab30';
                uploadProgressValue.style.position = 'absolute';
                uploadProgressValue.style.top = '0px';
                uploadProgressValue.style.left = '0px';
                uploadProgressValue.style.color = 'white';
                uploadProgress.append(uploadProgressValue);
                
                const batches = Math.ceil(returnedItemsData.length / batchSize);

                uploadProgressValue.textContent = `0/${batches}`;

                let failedCount = 0;

                for(let i = 0; i < batches; i++)
                {
                    const batchStart = i * batchSize;
                    const batchEnd = Math.min((i + 1) * batchSize, returnedItemsData.length);
                    const batch = returnedItemsData.slice(batchStart, batchEnd);

                    const data = {
                        SessionToken: this.$GetToken(),
                        Data: batch
                    };

                    console.log('send upload returned items request to ' + `${process.env.VUE_APP_BACKEND_URL}upload/returneditems`, data);
                    const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/returneditems`, data, {
                        headers:
                        {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async response =>{
                        console.log(`Batch #${i + 1} upload response`, response.data);
                        return response.data;
                    })
                    .catch(error =>
                    {
                        console.log(`Batch #${i + 1} received an error`, error);
                        if (error.response.status != 500)
                        {
                            this.$HandleBadRequest(error.response.status, error.response.data);
                        }
                        return null;
                    });

                    uploadProgressBar.style.width = `${Math.floor((i + 1) * 100 / batches)}%`;
                    uploadProgressValue.textContent = `${i + 1}/${batches}`;

                    if (result !== null)
                    {
                        failedCount += result.FailedCount;
                    }
                }

                if (failedCount > 0)
                {
                    const wrapper = document.getElementById('UploadWrapper');
                    const errorMessage = document.createElement('div');
                    errorMessage.style.color = 'red';
                    errorMessage.textContent = `${failedCount}回エラーがありました。詳細についてはコンソールを確認してください。`;
                    wrapper.append(errorMessage);
                }

                btn.textContent = 'OK';
                btn.onclick = function(event){
                    uploadProgress.remove();
                    this.SelectedSheet = '';
                    document.getElementById('SheetList').selectedIndex = -1;
                    event.target.remove();
                };
            }
            catch (err)
            {
                console.error('Could not upload Keikakumeisai', err);
            }
        },
        async UploadMoldData(moldData, fileInfo)
        {
            if (moldData === null ||
                moldData === undefined)
            {
                return;
            }
            
            const btn = document.getElementById('DataUploadBtn');
            btn.textContent = 'アップロード中';
            btn.onclick = null;

            try
            {
                const batchSize = 100;
                const uploadProgressContainer = document.getElementById('UploadProgress');

                const uploadProgress = document.createElement('div');
                uploadProgress.style.marginTop = '20px';
                uploadProgress.style.width = '400px';
                uploadProgress.style.height = '40px';
                uploadProgress.style.border = '1px solid black';
                uploadProgress.style.position = 'relative';
                uploadProgress.style.backgroundColor = '#b3b3b3';
                uploadProgress.style.borderRadius = '10px';
                uploadProgressContainer.append(uploadProgress);

                const uploadProgressBar = document.createElement('div');
                uploadProgressBar.style.width = '0%';
                uploadProgressBar.style.height = '100%';
                uploadProgressBar.style.backgroundColor = '#87beb1';
                uploadProgressBar.style.borderRadius = '10px';
                uploadProgress.append(uploadProgressBar);

                const uploadProgressValue = document.createElement('div');
                uploadProgressValue.style.width = '100%';
                uploadProgressValue.style.height = '100%';
                uploadProgressValue.style.display = 'grid';
                uploadProgressValue.style.placeContent = 'center';
                uploadProgressValue.style.color = '#23ab30';
                uploadProgressValue.style.position = 'absolute';
                uploadProgressValue.style.top = '0px';
                uploadProgressValue.style.left = '0px';
                uploadProgressValue.style.color = 'white';
                uploadProgress.append(uploadProgressValue);
                
                const batches = Math.ceil(moldData.length / batchSize);

                uploadProgressValue.textContent = `0/${batches}`;

                for(let i = 0; i < batches; i++)
                {
                    const batchStart = i * batchSize;
                    const batchEnd = Math.min((i + 1) * batchSize, moldData.length);
                    const batch = moldData.slice(batchStart, batchEnd);

                    const data = {
                        SessionToken: this.$GetToken(),
                        Data: batch,
                        BatchNumber: (i + 1),
                        FileInfo: fileInfo,
                    };

                    console.log('send upload mold data request to ' + `${process.env.VUE_APP_BACKEND_URL}upload/molds`, data);
                    let result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}upload/molds`, data, {
                        headers:
                        {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async response =>{
                        console.log(`Mold data batch #${i + 1} upload response`, response.data);
                        return { success: true };
                    })
                    .catch(error =>
                    {
                        console.log(`Mold data batch #${i + 1} received an error`, error);
                        if (error.response.status != 500)
                        {
                            this.$HandleBadRequest(error.response.status, error.response.data);
                        }

                        return { success: false, error: error.response.status };
                    });

                    if (result.success === false)
                    {
                        uploadProgressValue.textContent = 'Error! ' + result.error;
                        break;
                    }

                    uploadProgressBar.style.width = `${Math.floor((i + 1) * 100 / batches)}%`;
                    uploadProgressValue.textContent = `${i + 1}/${batches}`;
                }

                btn.textContent = 'OK';
                btn.onclick = function(event){
                    uploadProgress.remove();
                    this.SelectedSheet = '';
                    document.getElementById('SheetList').selectedIndex = -1;
                    event.target.remove();
                };
            }
            catch (err)
            {
                console.error('Could not upload mold data', err);
            }
        },
        async HandleFileChange(event)
        {
            this.SheetList = [];
            this.CheckedSheets = false;
            console.log('file change',event.target.files);
            
            this.HasSelectedFile = event.target.files.length > 0;

            if (this.HasSelectedFile === true)
            {
                document.getElementById('loading').textContent = 'loading...';
                this.UploadedExcelFileName = event.target.files[0].name;

                const buffer = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (event) => resolve(event.target.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsArrayBuffer(event.target.files[0]);
                });
                
                let wb = new ExcelJS.Workbook();
                
                try
                {
                    this.UploadedExcelFile = await wb.xlsx.load(buffer);
                    
                    let ev = {
                        target:{
                            options:[],
                            selectedIndex: 0
                        },
                    };

                    const app = this;
                    this.UploadedExcelFile.eachSheet(function(worksheet, sheetId) {
                        // console.log('has sheet ' + sheetId, worksheet);
                        // console.log('test ' + sheetId, worksheet.name);
                        app.SheetList.push({label: worksheet.name, value: worksheet.name, sheetID: sheetId});
                    });

                    ev.target.options = app.SheetList;
                    this.HasSelectedSheet(ev);

                    this.CheckedSheets = true;
                    // console.log('sheet list', this.SheetList);
                }
                catch (error)
                {
                    console.log('error', error);
                }

                document.getElementById('loading').textContent = '';
            }            
        },
        async ImportMold()
        {
            if (this.SelectedSheet === '' ||
                this.SelectedSheet === null ||
                this.SelectedSheet === undefined)
            {
                return;
            }

            const fileInfo = {
                Filename: this.UploadedExcelFileName,
                Sheetname: this.SelectedSheet
            };

            const sheet = this.UploadedExcelFile.getWorksheet(this.SelectedSheet);

            let result = await ImportMoldData(sheet);

            console.log('Molds', result);
            console.log('filenfo',fileInfo);

            const wrapper = document.getElementById('UploadWrapper');

            const uploadBtn = document.createElement('div');
            uploadBtn.classList.add('Button', 'ButtonNormal');
            uploadBtn.id = 'DataUploadBtn';
            uploadBtn.textContent = 'アップロード';
            uploadBtn.style.width = '130px';
            uploadBtn.style.margin = '30px 0px';
            wrapper.append(uploadBtn);
            uploadBtn.onclick = () =>{
                this.UploadMoldData(result, fileInfo);
            };
        },
        ImportSeiyakuhyou()
        {
            let wb = new ExcelJS.Workbook();
            console.log('new seiyakuhyou workbook', wb);
        },
        ImportZaiko()
        {
            if (this.SelectedSheet === '' ||
                this.SelectedSheet === null ||
                this.SelectedSheet === undefined)
            {
                return;
            }

            const fileInfo = {
                Filename: this.UploadedExcelFileName,
                Sheetname: this.SelectedSheet
            };

            const sheet = this.UploadedExcelFile.getWorksheet(this.SelectedSheet);

            let result = ImportZaikouData(sheet);
            console.log('zaiko result', result);

            // Remove empty entries
            // Empty meaning, everything is 0 escept for "Month" and "Year"
            for (let i = 0; i < result.length; i++)
            {
                result[i].SalesData = result[i].SalesData.filter(entry => {
                    return !(
                        entry.InventoryQuantity === 0 &&
                        entry.InventoryValue === 0 &&
                        entry.NumberOfSamples === 0 &&
                        entry.Orders === 0 &&
                        entry.ProductionCost === 0 &&
                        entry.SampleCost === 0 &&
                        entry.ShipmentsTotal === 0
                    );
                });
            }

            for (let i = 0; i < result.length; i++)
            {
                const cleaned = this.CleanProductNameFromReleaseVersion(result[i].ProductName);

                let releaseVersion = this.GetReleaseVersion(result[i].ProductName);
                result[i].Release = releaseVersion;
                result[i].ProductName = cleaned;
            }

            /*
            let janSales = 0;
            let janProfit = 0;
            let janSampleCost = 0;
            let janInventCost = 0;
            let plasticSales = 0;
            let plasticProfit = 0;
            let xpnaSales = 0;
            let xpnaProfit = 0;
            // Debug 2025 January for testing
            for (let i = 0; i < result.length; i++)
            {
                const product = result[i];
                // console.log('[ImportData](ImportZaiko) Check product', product.StyleNumber);
                const isPlastic = product.StyleNumber.length === 12 && product.StyleNumber[11] === 'P';
                const isXPNA = product.StyleNumber.length === 11 && product.StyleNumber[10] === 'N';

                for (let j = 0; j < product.SalesData.length; j++)
                {
                    const sd = product.SalesData[j];
                    // janSampleCost += sd.NumberOfSamples * product.ProductionCost;
                    // if (sd.NumberOfSamples !== 0)
                    // console.log(`[ImportData](ImportZaiko) ${product.StyleNumber} Add samples cost`, (sd.NumberOfSamples * product.ProductionCost));
                    // janInventCost += sd.InventoryQuantity * product.ProductionCost;
                    // if (sd.InventoryQuantity !== 0)
                    // console.log(`[ImportData](ImportZaiko) ${product.StyleNumber} Add inventory cost`, (sd.InventoryQuantity * product.ProductionCost));
                    if (sd.Month === 1 && sd.Year === 2025)
                    {
                        for (let k = 0; k < sd.SalesInformation.length; k++)
                        {
                            const sI = sd.SalesInformation[k];
                            janSales += sI.Sales;
                            janProfit += sI.Profit;
                            if (sI.Sales !== 0 || sI.Profit !== 0)
                            console.log(`[ImportData](ImportZaiko) ${product.StyleNumber} Add Sales: ${sI.Sales} Profit: ${sI.Profit}`);

                            if (isPlastic === true)
                            {
                                plasticSales += sI.Sales;
                                plasticProfit += sI.Profit;
                            }
                            else if (isXPNA === true)
                            {
                                xpnaSales += sI.Sales;
                                xpnaProfit += sI.Profit;
                            }
                        }
                    }
                }
            }
            console.log(`[ImportData](ImportZaiko) January Result`, {
                Sales: janSales,
                Profit: janProfit,
                Samples: janSampleCost,
                Stock: janInventCost,
                PlastiSales: plasticSales,
                plasticProfit: plasticProfit,
                XPNASales: xpnaSales,
                XPNAProfit: xpnaProfit,
                FiguresSales: janSales - plasticSales - xpnaSales,
                FiguresProfit: janProfit - plasticProfit - xpnaProfit,
            });
            */

            const wrapper = document.getElementById('UploadWrapper');

            const uploadBtn = document.createElement('div');
            uploadBtn.classList.add('Button', 'ButtonNormal');
            uploadBtn.id = 'DataUploadBtn';
            uploadBtn.textContent = 'アップロード';
            uploadBtn.style.width = '130px';
            uploadBtn.style.margin = '30px 0px';
            wrapper.append(uploadBtn);
            uploadBtn.onclick = () =>{
                this.UploadZaiko(result, fileInfo);
            };
        },
        ImportKeikakumeisai()
        {
            if (this.SelectedSheet === '' ||
                this.SelectedSheet === null ||
                this.SelectedSheet === undefined)
            {
                return;
            }

            const fileInfo = {
                Filename: this.UploadedExcelFileName,
                Sheetname: this.SelectedSheet
            };

            const sheet = this.UploadedExcelFile.getWorksheet(this.SelectedSheet);

            const result = ImportKeikakumeisaiData(sheet);
            const products = result.products;
            const missingData = result.missingStyleNumberInfo;
            
            console.log('Keikakumeisai data', result);
            let versionNames = [];
            // Check for models with the release version appended
            // to their product name
            for (let i = 0; i < products.length; i++)
            {
                const cleaned = this.CleanProductNameFromReleaseVersion(products[i].ProductName);
                if (products[i].ProductName.includes('次') === true)
                {
                    versionNames.push({i:i, name:products[i].ProductName, cleaned});
                }

                let releaseVersion = this.GetReleaseVersion(products[i].ProductName);
                products[i].Release = releaseVersion;
                products[i].ProductName = cleaned;
            }
            console.log('cleaned products', versionNames);

            const wrapper = document.getElementById('UploadWrapper');

            let uploadBtn = document.getElementById('DataUploadBtn');
            if (uploadBtn === null)
            {
                uploadBtn = document.createElement('div');
                uploadBtn.classList.add('Button', 'ButtonNormal');
                uploadBtn.id = 'DataUploadBtn';
                uploadBtn.textContent = 'アップロード';
                uploadBtn.style.width = '130px';
                uploadBtn.style.margin = '30px 0px';
                wrapper.append(uploadBtn);
            }
            
            uploadBtn.onclick = () =>{
                this.UploadKeikaku(products, fileInfo);
            };

            if (missingData.length > 0)
            {
                const missingInfo = document.createElement('div');
                missingInfo.id = 'MissingInfo';
                wrapper.append(missingInfo);

                const missingInfoHeader = document.createElement('h2');
                missingInfoHeader.id = 'MissingInfoHeader';
                missingInfoHeader.textContent = '品番抜けている商品がありました：';
                missingInfo.append(missingInfoHeader);

                const p = document.createElement('p');
                p.innerHTML = 'アップロードで続いたら、品番抜けている商品はインポートされてません。</br>後でExcelファイルに品番を追加して、もう一回アップロードしたら問題ありません。';
                missingInfo.append(p);

                const missingInfoContainer = document.createElement('div');
                missingInfoContainer.id = 'MissingInfoContainer';
                missingInfo.append(missingInfoContainer);

                for (let i = 0; i < missingData.length; i++)
                {
                    const info = missingData[i];

                    const entry = document.createElement('div');
                    entry.classList.add('MissingInfoEntry');
                    missingInfoContainer.append(entry);

                    let span = document.createElement('span');
                    span.innerHTML = `「${info.Row}行」`;
                    entry.append(span);

                    span = document.createElement('span');
                    span.innerHTML = info.Name;
                    entry.append(span);
                }
            }

            /*
            const previewLabel = document.createElement('h2');
            previewLabel.textContent = 'データプレビュー（軽く）';
            previewLabel.style.margin = '10px 0px 8px 0px';
            wrapper.append(previewLabel);

            const previewContainer = document.createElement('div');
            previewContainer.id = 'PreviewContainer';

            wrapper.append(previewContainer);

            for(let i = 0; i < result.length; i++)
            {
                const entry = document.createElement('div');
                entry.classList.add('DataPreviewEntry');
                previewContainer.append(entry);

                let zaiko = document.createElement('div');
                zaiko.textContent = result[i].Zaiko;
                entry.append(zaiko);

                let salesDate = document.createElement('div');
                salesDate.textContent = result[i].SellDate.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }).replace(',','');
                entry.append(salesDate);

                let prodName = document.createElement('div');
                prodName.textContent = result[i].ProductName;
                entry.append(prodName);
            }
            */
        },
        async ImportResult()
        {
            if (this.SelectedSheet === '' ||
                this.SelectedSheet === null ||
                this.SelectedSheet === undefined)
            {
                return;
            }

            const fileInfo = {
                Filename: this.UploadedExcelFileName,
                Sheetname: this.SelectedSheet
            };

            console.log('selected sheet for result data', this.SelectedSheet);
            const sheet = this.UploadedExcelFile.getWorksheet(this.SelectedSheet);

            const result = await ImportResultData(sheet);

            console.log('Imported results', result);

            const wrapper = document.getElementById('UploadWrapper');

            let uploadBtn = document.getElementById('DataUploadBtn');
            if (uploadBtn === null)
            {
                uploadBtn = document.createElement('div');
                uploadBtn.classList.add('Button', 'ButtonNormal');
                uploadBtn.id = 'DataUploadBtn';
                uploadBtn.textContent = 'アップロード';
                uploadBtn.style.width = '130px';
                uploadBtn.style.margin = '30px 0px';
                wrapper.append(uploadBtn);
            }
            
            uploadBtn.onclick = () =>{
                this.UploadResultData(result, fileInfo);
            };
        },
        ImportReturnItems()
        {
            if (this.SelectedSheet === '' ||
                this.SelectedSheet === null ||
                this.SelectedSheet === undefined)
            {
                return;
            }

            console.log('selected sheet for returned items', this.SelectedSheet);
            const sheet = this.UploadedExcelFile.getWorksheet(this.SelectedSheet);

            const result = ImportReturnedItemsData(sheet);

            const wrapper = document.getElementById('UploadWrapper');

            const uploadBtn = document.createElement('div');
            uploadBtn.classList.add('Button', 'ButtonNormal');
            uploadBtn.id = 'DataUploadBtn';
            uploadBtn.textContent = 'アップロード';
            uploadBtn.style.width = '130px';
            uploadBtn.style.margin = '30px 0px';
            wrapper.append(uploadBtn);
            uploadBtn.onclick = () =>{
                this.UploadReturnedItems(result);
            };
        },
        HasSelectedSheet(value)
        {
            if (value == null)
            {
                return;
            }
            if (value.target.selectedIndex == -1)
            {
                return;
            }

            this.SelectedSheet = value.target.options[value.target.selectedIndex].label;
            
            let buttons = document.getElementsByClassName('ImportSelectionButton');
            for (let i = 0; i < buttons.length; i++)
            {
                buttons[i].classList.remove('ImportRecommendation');
            }

            let target = document.getElementById('DataUploadBtn');
            if (target !== null)
            {
                target.remove();
            }

            target = document.getElementById('MissingInfo');
            if (target !== null)
            {
                target.remove();
            }

            if (this.SelectedSheet.toString().includes('在庫明細') === true)
            {
                document.getElementById('Import_Zaiko').classList.add('ImportRecommendation');
            }
            else if (this.SelectedSheet.toString().includes('計画明細') === true)
            {
                document.getElementById('Import_Keikakumeisai').classList.add('ImportRecommendation');
            }
            else if (this.SelectedSheet.toString().includes('不具合カ所') === true)
            {
                document.getElementById('Import_ReturnItems').classList.add('ImportRecommendation');
            }
        },
        GetReleaseVersion(productName)
        {
            // Regular expression to match the version format (e.g., "1次", "2次", etc.)
            const versionRegex = /(\d+)次/;
            
            // Test if the productName contains the version information
            const match = productName.match(versionRegex);
            
            // If a match is found, return the version number as a number
            if (match)
            {
                return parseInt(match[1], 10);
            }
            
            // If no version is found, return the default value of 1
            return 1;
        },
        CleanProductNameFromReleaseVersion(productName)
        {
            // Regular expression to match the version format (e.g., "1次", "2次", "(1次)", etc.)
            const versionRegex = /\s*\(?\d+次\)?/;
            
            // Replace the version information with an empty string and trim any trailing spaces
            return productName.replace(versionRegex, '').trim();
        },
    },
    data(){
        return{
            CurrentTab: 0,
            HasSelectedFile: false,
            CheckedSheets: false,
            UploadedExcelFileName: '',
            UploadedExcelFile: null,
            SheetList:[],
            SelectedSheet: '',
            EstimationUpload_Keikaku: null,
            EstimationUpload_SepKeikaku: null,
            KeikakuYear: new Date().getFullYear() + 1,
            KeikakuRev1Year: new Date().getFullYear(),
            KeikakuRev2Year: new Date().getFullYear(),
            KeikakuRev3Year: new Date().getFullYear(),
            KeikakuFileDate: '2024-12-15',
            KeikakuRev1FileDate: '2025-03-16',
            KeikakuRev2FileDate: '2025-06-16',
            KeikakuRev3FileDate: '2025-09-16',
            EstimationUpload_KeikakuRef1: null,
            EstimationUpload_SepKeikakuRef1: null,
            EstimationUpload_KeikakuRef2: null,
            EstimationUpload_SepKeikakuRef2: null,
            EstimationUpload_KeikakuRef3: null,
            EstimationUpload_SepKeikakuRef3: null,
            JuneDesctructionCost: 260,
            NovemberDesctructionCost: 320,
            IsUploadingKeikaku: false,
            UploadKeikakuButtonText: 'ファイルを選択してください',
            YearEndStockYear: new Date().getFullYear() - 1,
            YearEndStock: 0,
            YearEndStockSubmissionResult: '',
            EyaAdjustmentYear: '????',
            ProfitAdjustmentYears: [],
            ProfitAdjustmentSelectedIndex: 0,
            ProfitAdjustmentData: [],
        }
    }
}
</script>

<style>
#UploadWrapper
{
    padding: 25px;
}

#PreviewContainer
{
    
}

.DataPreviewEntry
{
    display: flex;
}

.DataPreviewEntry div
{
    flex: 0.1;
    white-space: nowrap;
}

.DataPreviewEntry div + div
{
    margin-left: 10px;
}

#ButtonOptions
{
    display: flex;
    opacity: 0;
    margin: 0px;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    -moz-transition: 0.5s;
}

.ButtonsVisible
{
    opacity: 1 !important;
    margin-top: 20px !important;
}

.ImportSelectionButton
{
    width: 150px;
    height: 150px;
    border-radius: 10px;
    background-color: #87beb1;
    color: white;
    display: grid;
    place-content: center;
    cursor: pointer;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    font-size: 1.5rem;
}

.ImportSelectionButton:hover
{
    background-color: #025944;
}

.ImportSelectionButton + .ImportSelectionButton
{
    margin-left: 10px;
}

#uploadfile
{
    font-size: 1.05rem;
}

#SheetList
{

}

.ImportRecommendation
{
    box-shadow: inset 0px 0px 10px 2px #025944;
}

#MissingInfo
{
    color: rgb(196, 32, 32);
    overflow: hidden;
    width: 630px;
    display: flex;
    flex-direction: column;

    #MissingInfoHeader
    {
        margin: 10px 0px 8px 0px;
    }

    p{
        font-style: italic;
        font-size: 0.9rem;
    }

    #MissingInfoContainer
    {
        flex: 1;
        overflow: auto;
        color:rgb(196, 32, 32);
        span:first-of-type{
            display: inline-block;
            width: 80px;
        }

        span + span {
            margin-left: 15px;
        }
    }
}

#UploadTabs
{
    display: flex;

    .UploadTab:first-of-type {
        border-top-left-radius: 8px;
    }

    .UploadTab:last-of-type {
        border-top-right-radius: 8px;
    }
}

.UploadTab
{
    background-color: #aaa;
    color: black;
    cursor: pointer;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    padding: 5px 20px 2px 20px;
    min-width: 80px;
    text-align: center;
}

.UploadTab:hover
{
    background-color: #87beb1;
    color: black;
}

.ActiveUploadTab
{
    background-color: #025944;
    color: white;
}

#MenuContent
{
    background-color: #dddddd;
    padding: 20px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
}

.KeikakuManual
{
    label {
        display: inline-block;
        width: 180px;
        text-align: left;
        font-size: 14px;
    }

    input {
        width: 70px;
        text-align: right;
        font-size: 18px;
        padding-right: 5px;
    }
}

#EyaGrid
{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px; /* Adjust spacing between items */
    padding: 16px; /* Optional padding around the grid */
    width: 100%; /* Ensures grid spans the container width */
    box-sizing: border-box; /* To include padding in width calculations */
}

.EyaGridItem
{
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 16px;
    text-align: center;
    box-sizing: border-box; /* Ensures padding doesn't affect item width */
}
</style>